export default __webpack_public_path__ + "static/media/stars.7ad9a53c.svg";